import UserImport from '@/views/Import/UserImport.vue'

const routes = {
  path: '/import',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/import/users',
      name: 'import-users',
      component: UserImport,
    },
  ],
}

export default routes
